import React from 'react';

interface Props {
  source: { drive_id?: string; uri?: string };
}

export const DriveVideo = (props: Props) => {
  if ('drive_id' in props.source) {
    return (
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <iframe
          src={`https://drive.google.com/file/d/${props.source.drive_id}/preview`}
          allow="autoplay; fullscreen; picture-in-picture"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderWidth: 0,
          }}
          title={props.source.drive_id}
        ></iframe>
      </div>
    );
  }

  return null;
};
